import { useRef } from "react";
import { Row, Col } from "@/utils/bootstrap";
import SvgSearchIcon from "@/app/layouts/header/header-common/search/search-helpers/search-icons/SvgSearchIcon";
import SvgClearText from "@/app/layouts/header/header-common/search/search-helpers/search-icons/SvgClearText";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
}
const CountryCodeSearch: React.FC<Props> = ({ searchTerm, setSearchTerm }) => {
  const t = useTranslation();
  const ref = useRef<any>(null);

  return (
    <Row
      className="m-0 d-flex align-items-center"
      style={{ gap: 8, background: "white" }}
    >
      {!searchTerm && (
        <Col
          className="p-0 col-auto"
          style={{ marginInlineStart: 8, marginInlineEnd: -12 }}
        >
          <SvgSearchIcon
            placeholder
            onClick={() => {
              ref.current?.focus();
            }}
          />
        </Col>
      )}
      <Col className="p-0">
        <input
          placeholder={t.search}
          ref={ref}
          autoFocus
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Col>
      {searchTerm && (
        <Col className="p-0 col-auto" style={{ marginInlineEnd: 8 }}>
          <SvgClearText
            onClick={() => {
              setSearchTerm("");
              ref.current?.focus();
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default CountryCodeSearch;
